import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error("useAuth must be used inside <AuthProvider>");
  }

  // Helper flags to make your UI code cleaner
  const isGuest = context.isLoggedIn === false;
  const isUser = context.isLoggedIn === true;
  const isAuthLoading = context.isLoggedIn === null;

  return {
    ...context,
    isGuest,
    isUser,
    isAuthLoading
  };
};